/**
 * http直接返回名单
 *  在业务中有存在非200的正常状态，以下白名单为直接返回的状态，或http请求
 * /\/api\/admin\/.+\/menu/
 * /\/api\/admin\/admin\/.+/
 */
export default {
  get: [
    {
      rUrl: /\/api\/operation\/tradeLog\/.+/,
      status: [40523]
    },
    {
      rUrl: /\/api\/cooler\/deviceSys\/.+\/pingback/,
      status: [4402, 8451]
    }
  ],
  post: [
    {
      rUrl: /\/api\/convenience\/meter\/.+\/devices/,
      status: [8614]
    },
    {
      rUrl: /\/api\/iot\/version/,
      status: [40711]
    },
    {
      rUrl: /\/api\/artificial\/abnl\/user\/train\/startTrain/,
      status: [50244]
    }
  ],
  put: [
    {
      rUrl: /\/api\/iot\/version\//,
      status: [40711]
    },
    {
      rUrl: /\/api\/operation\/vm\/mp\/move\/.+/,
      status: [40532]
    }
  ],
  delete: []
}
